import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { heroImages } from '../mock';

const items = [
  'Apertura P.IVA e regime fiscale ottimale',
  'Fatturazione elettronica automatizzata',
  'OSS/IOSS e IVA intracomunitaria',
  'Compilazione Prima nota & Registro corrispettivi',
  'Cash flow planning e budget ADV vs. margine netto',
  'Reportistica marginalità in collegamento con il media buying',
  'Compliance normativa e resi',
];

const PocketAdmin = () => (
  <div className="bg-[#2b2b2b]">
    <section className="pt-32 pb-16 md:pt-40 md:pb-24 bg-[#141414] relative overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{ backgroundImage: `url(${heroImages.accounting1})` }} />
      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="inline-block px-5 py-2.5 rounded-full border border-[#e9dfc0]/40 text-[#e9dfc0] text-[13px] mb-6">Servizi eCommerce</div>
        <h1 className="font-serif text-white text-5xl md:text-7xl leading-[1.05] mb-6">Pocket Administration</h1>
        <p className="text-[#e9dfc0]/85 text-[17px] max-w-3xl leading-relaxed">Consulenza Amministrativa & Logistica per E-commerce. Dall'idea alla spedizione: gestiamo il tuo e-commerce in modo semplice ed efficiente.</p>
      </div>
    </section>

    <section className="py-24">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-12 items-start">
        <div>
          <h2 className="font-serif text-white text-3xl md:text-4xl mb-8">Consulenza Amministrativa & Fiscale</h2>
          <ul className="space-y-3 text-[#e9dfc0]/90">
            {items.map((it) => (
              <li key={it} className="flex items-start gap-3"><Check className="w-5 h-5 text-[#e9dfc0] mt-0.5" /><span>{it}</span></li>
            ))}
          </ul>
        </div>
        <div className="aspect-square bg-cover bg-center rounded-2xl" style={{ backgroundImage: `url(${heroImages.accounting2})` }} />
      </div>
    </section>

    <section className="bg-[#e9dfc0] py-20">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <h2 className="font-serif text-[#2b2b2b] text-3xl md:text-4xl mb-6">La Pocket Administration è inclusa nei percorsi di Temporary Management, oppure puoi attivarla da sola.</h2>
        <Link to="/temporary-management" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-[#2b2b2b] text-[#e9dfc0] font-medium hover:bg-[#1e1e1e] transition-colors">
          Scopri come lavoriamo <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  </div>
);

export default PocketAdmin;
